/** Canonical bilingual section names shared by schema owners and name-only preview clients. */
export const sectionLabels = {
    "header": { ar: "الهيدر", en: "Header" },
    "nav": { ar: "شريط التنقل السفلي", en: "Bottom nav" },
    "announcement-bar": { ar: "شريط الإعلان", en: "Announcement bar" },
    "hero": { ar: "الواجهة الرئيسية", en: "Hero" },
    "collections": { ar: "تصفح الفئات", en: "Shop by collection" },
    "category-sections": { ar: "قسم فئة", en: "Category section" },
    "category-tabs": { ar: "تبويبات الفئات", en: "Category tabs" },
    "all-products": { ar: "كل المنتجات", en: "All products" },
    "footer": { ar: "التذييل", en: "Footer" },
    "banner": { ar: "بانر", en: "Banner" },
    "about": { ar: "من نحن", en: "About" },
    "faq": { ar: "الأسئلة الشائعة", en: "FAQ" },
    "product-details": { ar: "تفاصيل المنتج", en: "Product details" },
    "product-gallery": { ar: "معرض صور المنتج", en: "Product gallery" },
    "product-buybox": { ar: "منطقة الشراء", en: "Product buy box" },
    "product-buybar": { ar: "شريط الشراء العائم", en: "Floating buy bar" },
    "product-policies": { ar: "سياسات المنتج", en: "Product policies" },
    "product-related": { ar: "منتجات مشابهة", en: "Similar products" },
    "product-recently-viewed": { ar: "شوهدت مؤخرًا", en: "Recently viewed" },
    "product-reviews": { ar: "تقييمات العملاء", en: "Customer reviews" },
    "collection-header": { ar: "رأس صفحة الفئة", en: "Collection header" },
    "collection-products": { ar: "منتجات الفئة", en: "Collection products" },
    "stories": { ar: "قصصنا", en: "Our stories" },
    "top-seller": { ar: "منتج مميز", en: "Top seller" },
    "value-strip": { ar: "شريط المميزات", en: "Value strip" },
    "features": { ar: "صف الميزات", en: "Feature row" },
    "testimonials": { ar: "آراء العملاء", en: "Testimonials" },
    "video": { ar: "فيديو", en: "Video" },
    "instagram": { ar: "إنستغرام", en: "Instagram feed" },
    "newsletter": { ar: "نشرة بريدية", en: "Newsletter" },
    "countdown": { ar: "عداد تنازلي", en: "Countdown" },
    "before-after": { ar: "قبل وبعد", en: "Before / after" },
    "shop-the-look": { ar: "اشتري الإطلالة", en: "Shop the look" },
    "highlight-headline": { ar: "عنوان بصور", en: "Headline with photos" },
    "marquee-band": { ar: "شريط متحرك", en: "Scrolling band" },
    "scroll-reveal": { ar: "صورة بتكبر مع النزول", en: "Scroll reveal" },
    "search-prompt": { ar: "مش لاقي اللي بتدور عليه؟", en: "Search prompt" },
    "restaurant-header": { ar: "ترويسة المطعم", en: "Restaurant header" },
    "restaurant-hero": { ar: "واجهة المطعم", en: "Restaurant hero" },
    "restaurant-menu": { ar: "المنيو", en: "Menu" },
    "restaurant-rewards": { ar: "شريط الولاء", en: "Rewards strip" },
    "restaurant-order-cta": { ar: "زر الطلب للاستلام", en: "Order-ahead CTA" },
    "restaurant-footer": { ar: "تذييل المطعم", en: "Restaurant footer" },
};
export function getSectionLabel(type) {
    return Object.hasOwn(sectionLabels, type) ? sectionLabels[type] : undefined;
}
//# sourceMappingURL=section-labels.js.map